import { useEffect, useState } from 'react'

export type Theme = 'system' | 'light' | 'dark' | 'aurora'
export const THEMES: { key: Theme; label: string; swatch: string }[] = [
  { key: 'system', label: 'System', swatch: 'linear-gradient(135deg, #ffffff 50%, #0c0c0d 50%)' },
  { key: 'light', label: 'Light', swatch: '#ffffff' },
  { key: 'dark', label: 'Dark', swatch: '#0c0c0d' },
  { key: 'aurora', label: 'Aurora', swatch: 'linear-gradient(120deg, #6d7cff, #b56cff 55%, #ff7ab6)' },
]
const KEY = 'plan.theme'

export function storedTheme(): Theme {
  try {
    const v = localStorage.getItem(KEY)
    if (v === 'light' || v === 'dark' || v === 'aurora') return v
  } catch {}
  return 'system'
}

// index.html runs the same logic inline before first paint; this keeps React in sync afterwards
export function applyTheme(t: Theme) {
  const root = document.documentElement
  if (t === 'system') root.removeAttribute('data-theme')
  else root.setAttribute('data-theme', t)
}

export function useTheme(): [Theme, (t: Theme) => void] {
  const [theme, setTheme] = useState<Theme>(storedTheme)
  useEffect(() => {
    applyTheme(theme)
    try {
      if (theme === 'system') localStorage.removeItem(KEY)
      else localStorage.setItem(KEY, theme)
    } catch {}
  }, [theme])
  return [theme, setTheme]
}
